import { SET_BREADCRUMB_MAPPER } from '../types/breadCrumbMapperConstants'

export function setBreadCrumbMapper(items) {
  return {
    type: SET_BREADCRUMB_MAPPER,
    payload: items
  }
}
